import React from 'react';
import { useTranslation } from 'react-i18next';
import { TicketAddon } from 'types/TicketsState';

interface BundledAddonsListInsideOrderSummaryProps {
  addons: TicketAddon[];
  ticketQuantity: number;
}

const BundledAddonsListInsideOrderSummary: React.FC<
  BundledAddonsListInsideOrderSummaryProps
> = ({ addons, ticketQuantity }) => {
  const { t } = useTranslation();

  return (
    <p className="mt-[8px]">
      <span className="p3-semibold capitalize">
        {t('ticketSale.included')}:{' '}
      </span>
      <span className="p3-regular">
        {addons.map((item, index) => (
          <React.Fragment key={item.id}>
            {' '}
            {item.uses === 0 ? '' : `${ticketQuantity * item.uses} x `}
            {item.name}
            {index === addons.length - 1 ? '' : ','}
          </React.Fragment>
        ))}
      </span>
    </p>
  );
};

export default BundledAddonsListInsideOrderSummary;
